import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { TranslationService } from '@sdbn/common';
import { FilterAdministrationContext } from '../../filter-administration.context';
import { ConditionType, ConditionGroup, FilterType } from '../../filter-administration.model';
import { FilterEditorRegistryService } from '../../filter-editor-registry.service';

const source = 'app-condition-types';

@Component({
  selector: 'app-condition-types',
  templateUrl: './condition-types.component.html',
  styleUrls: ['./condition-types.component.scss']
})
export class FilterConditionsComponent implements OnInit, OnDestroy {

  conditionGroups = new Array<ConditionGroup>();

  filterAdministrationContext: FilterAdministrationContext;
  filterAdministrationContextSubscription: Subscription;

  @Input() set setfilterAdministrationContext(filterAdministrationContext: FilterAdministrationContext) {
    this.filterAdministrationContext = filterAdministrationContext;
    this.updateConditionGroups();
    this.filterAdministrationContextSubscription = this.filterAdministrationContext.contextChange$.subscribe(
      change => {
        try {
          if (change.source !== source && change.key === 'filter-changed') {
            this.updateConditionGroups();
          }
        } catch (error) {
          console.error(error);
        }
      }
    );
  }

  constructor(
    public translationService: TranslationService,
    private filterEditorRegistryService: FilterEditorRegistryService
  ) { }

  ngOnInit(): void {
  }

  ngOnDestroy() {
    if (this.filterAdministrationContextSubscription != null) {
      this.filterAdministrationContextSubscription.unsubscribe();
    }
  }

  public onDragTypeStart(event: DragEvent, condition: ConditionType) {
    event.dataTransfer.effectAllowed = "move";
    // IOS geht nur wenn gesetzt
    event.dataTransfer.setData("text/plain", "");

    this.filterAdministrationContext.setDraggedConditionTypeAdd(condition, source);
  }


  public onDragTypeEnd(event: DragEvent) {
    event.dataTransfer.effectAllowed = "move";
    // IOS geht nur wenn gesetzt
    event.dataTransfer.setData("text/plain", "");

    this.filterAdministrationContext.setDraggedConditionTypeAdd(null, source);
  }

  private updateConditionGroups() {
    if (this.filterAdministrationContext != null && this.filterAdministrationContext.getFilterType() != null) {
      if (FilterType.TRANSPORT_LIST === this.filterAdministrationContext.getFilterType()) {
        this.conditionGroups = this.filterEditorRegistryService.getTransportConditionGroups();
      } else if (FilterType.VISITOR_LIST === this.filterAdministrationContext.getFilterType()) {
        this.conditionGroups = this.filterEditorRegistryService.getVisitorConditionGroups();
      }
    }
  }
}
